import styled from "styled-components"

export const Component = styled.div<{ $k: number; $isCancelled?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
  border: 1px solid
    ${({ $isCancelled }) =>
      $isCancelled ? "rgba(216, 72, 74, 0.28)" : "rgba(15, 23, 42, 0.06)"};
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04),
    0 2px 8px rgba(15, 23, 42, 0.04);

  &:hover {
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1),
      0 2px 4px rgba(15, 23, 42, 0.06);
    transform: translateY(-2px);
  }

  opacity: 0;
  ${({ $k, theme }) =>
    theme.animations.types.fadeLeft +
    theme.animations.durations.main +
    theme.animations.delays.main($k)}
`

export const StatusBadge = styled.span`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px 4px 8px;
  border-radius: 999px;
  background-color: #d8484a;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  box-shadow: 0 2px 6px rgba(216, 72, 74, 0.35);

  svg {
    width: 12px;
    height: 12px;
  }
`

export const CardContent = styled.div<{ $isCancelled?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  width: 100%;
  opacity: ${({ $isCancelled }) => ($isCancelled ? 0.78 : 1)};
  transition: opacity 0.25s ease;
`

export const ImageContainer = styled.div<{ $isCancelled?: boolean }>`
  width: 100%;
  aspect-ratio: 2;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-color: #f4f6f8;
  filter: saturate(${({ $isCancelled }) => ($isCancelled ? 0 : 1)});

  img {
    min-height: 100%;
    max-width: 100%;
    object-fit: cover;
  }
`

export const EventInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  padding: 16px;
`

export const Eyebrow = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #8a94a6;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
`

export const EventName = styled.span`
  font-size: 20px;
  color: #1a1f2e;
  font-weight: 700;
  line-height: 1.25;
  margin-top: 4px;
`

export const MetaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`

export const MetaRow = styled.span`
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
`

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-height: 44px;

  @media (max-width: ${({ theme }) => theme.bp.xsmall}px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`

export const Icons = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  opacity: 1;
  transition: opacity 0.25s ease;
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};

  button {
    background: none;
    border: none;
    outline: none;
    padding: 6px 8px;
    border-radius: 8px;
    transition: background-color 0.2s ease;
    cursor: pointer;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font: inherit;
    color: inherit;

    svg {
      width: 22px;
      height: 22px;
      color: ${({ theme }) => theme.colors.blue.main};
    }

    span {
      font-size: 11px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.blue.main};
    }

    &:hover {
      background-color: rgba(0, 97, 230, 0.08);
    }

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.blue.main};
      outline-offset: 2px;
    }

    &:disabled,
    &[aria-disabled="true"] {
      cursor: not-allowed;
      svg,
      span {
        color: #9ca3af;
      }
      &:hover {
        background-color: transparent;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    opacity: 1;
  }
`

export const TicketsQntWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: #1a1f2e;
`

export const TicketsQntNumber = styled.span`
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
`

export const TicketsQntLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
`
